var runtime = require("../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"cover":"TUY0V"};
module.exports._getCss = function(wrap, process){return ""+wrap+" .TUY0V{position:absolute;top:0;left:0;right:0;bottom:0;background-color:#000;z-index:1}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

